import { Component } from '@angular/core';

@Component({
  selector: 'app-analyst-reports',
  templateUrl: './analyst-reports.component.html',
  styleUrls: ['./analyst-reports.component.scss']
})
export class AnalystReportsComponent {

}
